import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../shared/auth.service';
import { TeamMembershipService } from '../../shared/team-membership.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-no-access',
  standalone: true,
  imports: [CommonModule, TranslateModule, RouterModule],
  templateUrl: './no-access.component.html'
})
export class NoAccessComponent implements OnInit, OnDestroy {

  constructor(
    private titleService: Title,
    private translateService: TranslateService,
    private authService: AuthService,
    private membership: TeamMembershipService,
    private router: Router) { }

  async ngOnInit() {
    document.body.classList.add('background');
    this.titleService.setTitle(`${this.translateService.instant('pages.no-access-title')} | ${environment.appName}`);

    // Someone who does have a team has no business on this page (typed URL, stale tab).
    if (await this.membership.hasTeam()) {
      this.router.navigate(['/app']);
    }
  }

  ngOnDestroy() {
    document.body.classList.remove('background');
  }

  onSignOut() {
    this.membership.clear();
    this.authService.signOut().subscribe(() => {
      this.router.navigate(['/signed-out']);
    });
  }

}
